import Swiper, { Navigation, Pagination } from 'swiper'

Swiper.use([Navigation, Pagination])

new Swiper('.js-interfaceSlider .swiper-container', {
  loop: true,
  loopAdditionalSlides: 8,
  spaceBetween: 80,
  navigation: {
    nextEl: '.js-interfaceSliderNext',
    prevEl: '.js-interfaceSliderPrev',
  },
  pagination: {
    el: '.js-interfaceSlider .swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  breakpoints: {
    320: {
      spaceBetween: 35,
    },
    768: {
      spaceBetween: 20,
    },
    1280: {
      spaceBetween: 80,
    },
  },
})

const $interfaceTooltipMobile = $('.js-interfaceTooltipMobile')

$('.js-interfacePoint').on('click', (e) => {
  const current = $(e.currentTarget)
  const tooltip = current.find('.interface-tooltip').clone()

  $interfaceTooltipMobile.html(tooltip)
  $interfaceTooltipMobile.addClass('is_visible')
})

$('body').on('touchstart', () => {
  $interfaceTooltipMobile.removeClass('is_visible')
})
